<template>
    <div class="lms__superadmin_customer_edit_form">
        <form-text
            :label="$t('lms.customer.labels.name')"
            :name="$t('forms.dataVvAs.name')"
            :required="true"
            :v-validate="'required|max:45'"
            :data-vv-as="$t('forms.dataVvAs.name')"
            v-model="customercontactName"
        />
        <form-text
            :label="$t('lms.customer.labels.email')"
            :name="$t('forms.dataVvAs.email')"
            :data-vv-as="$t('forms.dataVvAs.email')"
            :required="isPhoneRequired"
            :v-validate="{ required: isPhoneRequired, email: true, max: 120 }"
            v-model="customercontactEmail"
        />
        <form-phone
            :label="$t('lms.customer.labels.phone')"
            :name="$t('forms.dataVvAs.phone')"
            :data-vv-as="$t('forms.dataVvAs.phone')"
            :required="isEmailRequired"
            :v-validate="{ required: isEmailRequired, regex: /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/ }"
            v-model="customercontactPhone"
        />
        <form-text
            :label="$t('lms.customer.labels.address')"
            :name="'address'"
            v-model="customercontactAddress"
        />
        <form-textarea
            :label="$t('lms.customer.labels.notes')"
            :name="'notes'"
            v-model="customercontactNotes"
        />
        <form-submit
            @reset="customercontactReset"
            @submit="customercontactSubmit"
        />
        <pop-notify
            :class="'pop__notify--validation'"
            ref="popnotifyvalidation"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import FormText from '@/components/default/forms/FormText'
import FormSubmit from '@/components/default/forms/FormSubmit'
import PopNotify from '@/components/default/shared/PopNotify'
import FormTextarea from '@/components/default/forms/FormTextarea'
import FormPhone from '@/components/default/forms/FormPhone'

export default {
  name: 'lms-superadmin-customer-contact-edit-form',
  components: {
    FormPhone,
    FormTextarea,
    PopNotify,
    FormSubmit,
    FormText
  },
  computed: {
    isPhoneRequired () {
      return Boolean(this.customercontactEmail) || (!this.customercontactPhone && !this.customercontactEmail)
    },
    isEmailRequired () {
      return Boolean(this.customercontactPhone) || (!this.customercontactPhone && !this.customercontactEmail)
    },
    //
    customercontactName: {
      get () {
        return this.$store.getters.getLmsSuperadminCustomerContactName
      },
      set (value) {
        this.$store.dispatch('lmsSuperadminCustomerContactSetName', value)
      }
    },
    customercontactEmail: {
      get () {
        return this.$store.getters.getLmsSuperadminCustomerContactEmail
      },
      set (value) {
        this.$store.dispatch('lmsSuperadminCustomerContactSetEmail', value)
      }
    },
    customercontactPhone: {
      get () {
        return this.$store.getters.getLmsSuperadminCustomerContactPhone
      },
      set (value) {
        this.$store.dispatch('lmsSuperadminCustomerContactSetPhone', value)
      }
    },
    customercontactAddress: {
      get () {
        return this.$store.getters.getLmsSuperadminCustomerContactAddress
      },
      set (value) {
        this.$store.dispatch('lmsSuperadminCustomerContactSetAddress', value)
      }
    },
    customercontactNotes: {
      get () {
        return this.$store.getters.getLmsSuperadminCustomerContactNotes
      },
      set (value) {
        this.$store.dispatch('lmsSuperadminCustomerContactSetNotes', value)
      }
    }
  },
  methods: {
    allowRedirectBeforeRouteLeave: function () {
      this.$eventBus.$emit('customer-contact-submit')
    },
    //
    customercontactReset: function () {
      this.$store.dispatch('lmsSuperadminCustomerContactReset')
    },
    customercontactSubmit: function () {
      this.$validator.validateAll().then((result) => {
        const route = this.$route.name
        let actionName
        if (result) {
          if (route.includes('customer-contact-add')) {
            actionName = 'lmsSuperadminCustomerContactCreate'
          } else if (route.includes('customer-contact-edit')) {
            actionName = 'lmsSuperadminCustomerContactUpdate'
          }
          this.$store.dispatch(actionName)
          this.$validator.pause()
          this.allowRedirectBeforeRouteLeave()
        } else {
          this.$refs.popnotifyvalidation.openNotify()
        }
      })
    }
  }
}
</script>
